var map = {
	"./holidays/01-new-year.png": 2724,
	"./holidays/02-spring-festival.png": 38825,
	"./holidays/03-lantern-festival.png": 58019,
	"./holidays/04-qingming-festival.png": 97414,
	"./holidays/05-labor-day.png": 46229,
	"./holidays/06-dragon-boat.png": 67585,
	"./holidays/07-cpc-founding.png": 65927,
	"./holidays/08-army-day.png": 65913,
	"./holidays/09-teachers-day.png": 27900,
	"./holidays/10-mid-autumn.png": 82415,
	"./holidays/11-national-day.png": 57042,
	"./runtime/nav-mid-autumn.png": 69630,
	"./runtime/nav-national-day-77.png": 54705,
	"./scientists/01-qian-xuesen.png": 64244,
	"./scientists/02-yuan-longping.png": 46397,
	"./scientists/03-tu-youyou.png": 7498,
	"./scientists/04-deng-jiaxian.png": 86502,
	"./scientists/05-hua-luogeng.png": 28716,
	"./scientists/06-chen-jingrun.png": 65277,
	"./scientists/07-zhu-kezhen.png": 35903,
	"./scientists/08-li-siguang.png": 759,
	"./scientists/09-mao-yisheng.png": 19639,
	"./scientists/10-chien-shiung-wu.png": 5685,
	"./solar-terms/01-lichun.png": 40469,
	"./solar-terms/02-yushui.png": 99480,
	"./solar-terms/03-jingzhe.png": 41889,
	"./solar-terms/04-chunfen.png": 2456,
	"./solar-terms/05-qingming.png": 11480,
	"./solar-terms/06-guyu.png": 49835,
	"./solar-terms/07-lixia.png": 47153,
	"./solar-terms/08-xiaoman.png": 63956,
	"./solar-terms/09-mangzhong.png": 23767,
	"./solar-terms/10-xiazhi.png": 89787,
	"./solar-terms/11-xiaoshu.png": 93528,
	"./solar-terms/12-dashu.png": 56867,
	"./solar-terms/13-liqiu.png": 34447,
	"./solar-terms/14-chushu.png": 1806,
	"./solar-terms/15-bailu.png": 41264,
	"./solar-terms/16-qiufen.png": 15078,
	"./solar-terms/17-hanlu.png": 94875,
	"./solar-terms/18-shuangjiang.png": 32091,
	"./solar-terms/19-lidong.png": 48434,
	"./solar-terms/20-xiaoxue.png": 66432,
	"./solar-terms/21-daxue.png": 17725,
	"./solar-terms/22-dongzhi.png": 43974,
	"./solar-terms/23-xiaohan.png": 20536,
	"./solar-terms/24-dahan.png": 97259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49694;